/* eslint-disable no-useless-escape */
import companies_item from './companyItems';
export const ACCESS_TOKEN = 'accessToken';
export const REFRESH_TOKEN = 'refreshToken';
export const ID_TOKEN = 'idToken';
export const TOKEN_INVITATION = 'tokenInvitation';
export const SESSION_TOKEN = 'sessionToken';
export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.\[\]{}\(\)?\-\"!@#%&\/,><\':;|_~`])\S{8,99}$/;

export enum APP_REFERER {
  ACCOUNTS = 'accounts',
  PAYROLLR = 'payrollr',
  TIMESHEETS = 'timesheets',
  EDECLARATION = 'edeclaration',
}

export const COMPANY_ITEMS = companies_item;
export const MOBILE_BREAK_POINT = 576;
export const MEDIUM_BREAK_POINT = 768;
export const LARGE_BREAK_POINT = 992;
export const MAX_FILE_SIZE = 2097152;
export const DEFAULT_PADDING_HEIGHT = 32;
export const STAR_STRING = '\u002A';
export const VERIFICATION_ERROR_CODES = {
  NOT_AUTHORIZED: 'NotAuthorizedException',
  CODE_MISMATCH: 'CodeMismatchException',
  EXPIRED_CODE: 'ExpiredCodeException',
  LIMIT_EXCEEDED: 'LimitExceededException',
};

export * from './color';
